import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { Cloudinary } from 'services/cloudinary';
import { XmStore, XmStoreUtil } from 'services/store';
import { Util } from 'services/util';
import { CmsCore } from 'store/cms/models';

@Component({
    selector: 'promo-banner',
    templateUrl: './promo-banner.html',
    styleUrls: ['./promo-banner.scss'],
    standalone: false
})
export class XmPromoBannerComponent implements OnInit, OnDestroy {
    @Input() public banner: BillingBanner;
    @Input() public promoList: BannerPromos[] = [];
    public infoIconOptions: MediaImageOptions;
    private subscriptions: Subscription[] = [];
    private xmStore: XmStore;

    constructor(xmStore: XmStore) {
        Object.assign(this, { xmStore });
    }

    public ngOnInit(): void {
        this.subscriptions.push(XmStoreUtil.subscribe(this.xmStore.peek<CmsCore>(CmsCore), (cms: CmsCore) => {
            this.infoIconOptions = {
                mobile: Cloudinary.generateMediaFromCms(cms.icons.infoIconGrey)
            };
        }));
    }

    public ngOnDestroy(): void {
        Util.unsubscribeAll(this.subscriptions);
    }
}
